/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // ✅ Works with Angular 15+ and Angular 19

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

// ❌ DO NOT import 'core-js/es7/reflect' — it is removed in core-js >=3
// ✅ Nothing else required unless you're polyfilling old browser features
